import { createContext, useContext } from 'react';

/**
 * true のとき、ページは別の枠（新UI /test-ui の左メニュー）の中に描かれている。
 * ResponsiveAppShell は自前のサイドバーとスマホのトップバーを出さず、本文だけを描く。
 */
export const EmbeddedShellContext = createContext(false);

export const useIsEmbeddedShell = () => useContext(EmbeddedShellContext);
